module.exports = __webpack_public_path__ + "img/color-tree-tattoo-12.jpg";